import React, { useState } from 'react';

const BuyingPage = ({ setActiveTab }) => {
  const [selectedRegion, setSelectedRegion] = useState('');
  const [priceRange, setPriceRange] = useState('');
  const [propertyType, setPropertyType] = useState('');
  const [selectedTransaction, setSelectedTransaction] = useState('');



  const transactionTypes = ["Compra", "Alquiler"]

  const priceRanges = [
    'Menos de $100,000', '$100,000 - $200,000', '$200,000 - $300,000',
    '$300,000 - $500,000', '$500,000 - $1,000,000', 'Más de $1,000,000'
  ];

  const propertyTypes = [
    'Casa', 'Apartamento', 'Condominio', 'Terreno', 'Comercial', 'Finca'
  ];

  return (
    <div className="buying-container">
      <div className="buying-header">
        <h1>Encuentra tu Propiedad Ideal</h1>
        <p>Explora miles de propiedades en Costa Rica o deja que nuestra IA te ayude</p>
      </div>

      {/* AI Assistant Highlight
      <div className="ai-highlight-section">
        <div className="ai-highlight-card">
          <div className="ai-highlight-content">
            <h2>🤖 ¿Prefieres que nuestra IA te ayude?</h2>
            <p>
              En lugar de usar filtros tradicionales, simplemente describe lo que buscas. 
              Nuestra inteligencia artificial entiende el lenguaje natural y encuentra propiedades 
              que coinciden perfectamente con tus necesidades.
            </p>
            <div className="ai-benefits">
              <div className="benefit-item">✅ Búsqueda más intuitiva</div>
              <div className="benefit-item">✅ Resultados más precisos</div>
              <div className="benefit-item">✅ Ahorra tiempo</div>
              <div className="benefit-item">✅ No se pierde ninguna oportunidad</div>
            </div>
            <button 
              className="button-primary ai-cta-btn"
              onClick={() => setActiveTab('chatbot')}
            >
              Hablar con Asistente IA
            </button>
          </div>
        </div>
      </div> */}

      {/* Traditional Search (Formspree lead capture) */}
      <div className="traditional-search-section">
        <h2>Búsqueda Tradicional</h2>
        <p>Si prefieres usar filtros, aquí tienes las opciones básicas:</p>

        <form
          action="https://formspree.io/f/meovonqz"
          method="POST"
          className="search-filters"
        >
          {/* Identify the form in your inbox */}
          <input type="hidden" name="_subject" value="Búsqueda Tradicional - Link Real Estate" />
          <input type="hidden" name="form_name" value="traditional_search" />
          {/* Optional thank-you redirect */}
          {/* <input type="hidden" name="_next" value="https://tusitio.com/gracias" /> */}
          {/* Simple honeypot anti-spam */}
          <input type="text" name="_gotcha" style={{ display: 'none' }} tabIndex="-1" autoComplete="off" />

          <div className='search-filters'>
            <label htmlFor="transaction">Tipo de transacción</label>
            <select
              id="transaction"
              name="transaction"
              value={selectedTransaction}
              onChange={(e) => setSelectedTransaction(e.target.value)}
              className="filter-select"
              required
            >
              <option value="">Seleccionar tipo transacción</option>
              {transactionTypes.map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </select>
          </div>

          <div className="search-filters">
            <div className="filter-group">
              <label htmlFor="region">Ubicación</label>
              <input
                type="text"
                id="region"
                name="region"
                placeholder="Ingresar ubicación"
                value={selectedRegion}
                onChange={(e) => setSelectedRegion(e.target.value)}
                className="filter-select"
                required
              />
            </div>

            <div className="filter-group">
              <label htmlFor="priceRange">Rango de Precio</label>
              <select
                id="priceRange"
                name="priceRange"
                value={priceRange}
                onChange={(e) => setPriceRange(e.target.value)}
                className="filter-select"
                required
              >
                <option value="">Seleccionar precio</option>
                {priceRanges.map(range => (
                  <option key={range} value={range}>{range}</option>
                ))}
              </select>
            </div>

            <div className="filter-group">
              <label htmlFor="propertyType">Tipo de Propiedad</label>
              <select
                id="propertyType"
                name="propertyType"
                value={propertyType}
                onChange={(e) => setPropertyType(e.target.value)}
                className="filter-select"
                required
              >
                <option value="">Seleccionar tipo</option>
                {propertyTypes.map(type => (
                  <option key={type} value={type}>{type}</option>
                ))}
              </select>
            </div>

            <button type="submit" className="button-primary search-btn">
              Buscar Propiedades
            </button>
          </div>
        </form>
      </div>


      {/* Why AI is Better Section */}
      <div className="why-ai-section">
        <h2>¿Por qué nuestra IA es mejor que los filtros tradicionales?</h2>
        <div className="comparison-grid">
          <div className="comparison-card traditional">
            <h3>❌ Búsqueda Tradicional</h3>
            <ul>
              <li>Filtros limitados y rígidos</li>
              <li>Puede perder propiedades perfectas</li>
              <li>Requiere conocimiento técnico</li>
              <li>Proceso lento y tedioso</li>
            </ul>
          </div>

          <div className="comparison-card ai">
            <h3>✅ Asistente IA</h3>
            <ul>
              <li>Entiende lenguaje natural</li>
              <li>Encuentra propiedades ocultas</li>
              <li>Fácil de usar para todos</li>
              <li>Resultados instantáneos</li>
            </ul>
          </div>
        </div>

        <div className="ai-cta-bottom">
          <button 
            className="button-primary"
            onClick={() => setActiveTab('contact')}
          >
            Contactanos
          </button>
        </div>
      </div>
    </div>
  );
};

export default BuyingPage;
